var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'article-card',
    'article-card--horizontal',
    'article-card--horizontal-tech-issue',
    'article-card--with-hover' ]},[_c('div',{staticClass:"article-card__img--tech-issue-backround"},[_c('BgImage',{staticClass:"article-card__img--tech-issue",attrs:{"url":_vm.img,"border":_vm.$bps('xs') ? false : true}})],1),_c('div',{class:['article-card__content', 'article-card__content--tech-issue']},[(_vm.title)?_c('h4',{staticClass:"article-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }